var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.689 70.0013C128.85 70.0013 129.796 69.0591 129.754 67.8983C129.267 54.3924 124.102 41.4487 115.108 31.3035C105.647 20.6327 92.6058 13.797 78.4481 12.0883C64.2903 10.3795 49.997 13.9161 38.2695 22.0296C26.5421 30.1432 18.193 42.2715 14.8001 56.1226C11.4072 69.9736 13.2056 84.5877 19.8555 97.2028C26.5053 109.818 37.5459 119.56 50.8906 124.588C64.2352 129.616 78.9595 129.582 92.2806 124.492C104.946 119.652 115.508 110.561 122.182 98.8091C122.756 97.7991 122.353 96.5265 121.323 95.9897C120.293 95.4529 119.026 95.8552 118.45 96.8636C112.253 107.704 102.484 116.09 90.7792 120.563C78.4186 125.286 64.7561 125.318 52.3736 120.652C39.9912 115.987 29.7467 106.947 23.5763 95.2414C17.406 83.5359 15.7372 69.9756 18.8854 57.1233C22.0337 44.271 29.7808 33.0171 40.6626 25.4886C51.5445 17.9601 64.8071 14.6786 77.9441 16.2641C91.081 17.8496 103.182 24.1925 111.96 34.0938C120.272 43.4696 125.06 55.4211 125.545 67.8985C125.59 69.0591 126.527 70.0013 127.689 70.0013Z",
    fill: "#7663EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2109 70L62.7109 87.5L97.7109 52.5",
    stroke: "#7663EB",
    strokeWidth: 4.375,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f99bb08a7c68ac0e8054cde8ae167662.svg";
export { ForwardRef as ReactComponent };